import type {
    SpaceOverlayIntent,
    SpaceOverlayModel,
} from '@toolproof-core/visualization/runtime/_contract/overlay';

import { MODE_OPTIONS, MODE_SECTION_ID } from '@/workflow/modes/_@shared/_data/modeOverlay';
import type { AdapterMode } from '@/workflow/_contract/mode';

export function withModeOverlay(args: {
    adapterMode: AdapterMode;
    overlayModel: SpaceOverlayModel | undefined;
}): SpaceOverlayModel {
    const modeSection = {
        sectionKind: 'select' as const,
        sectionId: MODE_SECTION_ID,
        label: 'Adapter',
        selectedValue: args.adapterMode,
        options: [...MODE_OPTIONS],
    };

    if (args.overlayModel === undefined) {
        return {
            overlayId: `workflow-${args.adapterMode}`,
            title: args.adapterMode === 'builder' ? 'Workflow Builder' : 'Workflow Runner',
            sections: [modeSection],
        };
    }

    return {
        ...args.overlayModel,
        sections: [modeSection, ...args.overlayModel.sections],
    };
}

export function resolveModeIntent(intent: SpaceOverlayIntent): AdapterMode | undefined {
    if (intent.overlayIntentKind !== 'select-changed') return undefined;
    if (intent.sectionId !== MODE_SECTION_ID) return undefined;
    if (intent.value !== 'builder' && intent.value !== 'runner') return undefined;

    return intent.value;
}
